import {Injectable, signal} from '@angular/core';
import '../types/window.types';
import {environment} from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class TokenService {
    private readonly BRIDGE_CHECK_INTERVAL = 100; // ms
    private readonly BRIDGE_CHECK_TIMEOUT = 60000; // ms
    private readonly TOKEN_CHECK_INTERVAL = 100; // ms
    private readonly TOKEN_CHECK_TIMEOUT = 60000; // ms

    readonly token = signal<string | null>(null);

    constructor() {
        this.initializeToken();
    }

    private initializeToken(): void {
        // Try to get a token from URL parameters (if Flutter passes it via query params) ONLY DEV MODE
        if (!environment.production) {
            const urlParams = new URLSearchParams(window.location.search);
            const tokenFromUrl = urlParams.get('token');

            if (tokenFromUrl) {
                this.setToken(tokenFromUrl);
                return;
            }
        }

        // Try to get a token from Flutter through a special handler
        this.requestTokenFromFlutter();
    }

    private isAuth10tixBridgeAvailable(): boolean {
        return !!window.Auth10tixBridge?.getJwtToken;
    }

    private async waitForAuth10tixBridge(): Promise<boolean> {
        if (this.isAuth10tixBridgeAvailable()) {
            return true;
        }

        return new Promise((resolve) => {
            const startTime = Date.now();
            const checkInterval = setInterval(() => {
                if (this.isAuth10tixBridgeAvailable()) {
                    clearInterval(checkInterval);
                    resolve(true);
                } else if (Date.now() - startTime > this.BRIDGE_CHECK_TIMEOUT) {
                    clearInterval(checkInterval);
                    console.warn('Auth10tixBridge wait timeout');
                    resolve(false);
                }
            }, this.BRIDGE_CHECK_INTERVAL);
        });
    }

    private async requestTokenFromFlutter(): Promise<void> {
        console.warn('token should be initialized by Flutter');

        const bridgeAvailable = await this.waitForAuth10tixBridge();

        if (bridgeAvailable && window.Auth10tixBridge?.getJwtToken) {
            console.warn('getJwtToken exists, trying to get token from Flutter');
            const token = window.Auth10tixBridge.getJwtToken();
            if (token) {
                console.warn('token received from Flutter:', token);
                this.setToken(token);
                return;
            }
        }
    }

    async waitForToken(): Promise<boolean> {
        const token = this.getToken();
        if (token) {
          return true;
        }

        return new Promise((resolve) => {
          const startTime = Date.now();
          const checkInterval = setInterval(() => {
            const currentToken = this.getToken();
            if (currentToken) {
              clearInterval(checkInterval);
              resolve(true);
            } else if (Date.now() - startTime > this.TOKEN_CHECK_TIMEOUT) {
              clearInterval(checkInterval);
              console.warn('Token wait timeout');
              resolve(false);
            }
          }, this.TOKEN_CHECK_INTERVAL);
        });
      }

    setToken(token: string): void {
        this.token.set(token);
    }

    clearToken(): void {
        this.token.set(null);
    }

    getToken(): string | null {
        return this.token();
    }
}

